<template>
  <USelectMenu
    v-model="_value"
    :items="customerForms"
    label-key="idCustomerForm"
    by="idCustomerForm"
    :placeholder="$t('form.select')"
  >
    <template #default="{ modelValue: selected }">
      <div v-if="selected" class="flex items-center">
        <p class="block opacity-90 line-clamp-1">
          {{ selected.form.title }} - ({{ selected.createdLabel }})
        </p>
      </div>
    </template>

    <template #item="{ item }">
      <div v-if="item" class="flex items-center justify-between">
        <div>
          <p class="text-sm opacity-90 line-clamp-1">
            {{ item.form.title }} - {{ item.createdLabel }}
          </p>
          <customer-form-status :customer-form="item" :include-reservation="false" />
        </div>
      </div>
    </template>
  </USelectMenu>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'

import CustomerFormStatus from '@/components/customerForm/elements/Status.vue'

interface Props {
  modelValue?: any
  customer?: any
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
  customer: null,
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: any): void
}>()

const { $notification, $api } = useNuxtApp()

const customerForms = ref<any[]>([])

const _value = computed({
  get () {
    return props.modelValue
  },
  set (value) {
    emit('update:modelValue', value)
  },
})

onMounted(() => {
  fetchCustomerForms()
})

async function fetchCustomerForms () {
  try {
    const idCustomer = props.customer?.idCustomer || props.customer?.id
    const response = idCustomer
      ? await $api.customer.forms(String(idCustomer), { limit: 20 })
      : null

    if (response?.items) {
      customerForms.value = response.items
    }
  } catch (e: any) {
    console.log(e)
    $notification.error({ errors: e.errors })
  }
}
</script>
